module.exports = __webpack_public_path__ + "media/images/icon/white/ico_monitor-3c0ed050276766d20a52601ec899f226.svg";